import { SET_PLUGINS, SET_PLUGIN_LIST } from './actions';
import { merge } from '@its/util';

export default (state = [], action) => {
  switch (action.type) {
    case SET_PLUGINS:
      return merge(state, { items: action.payload });
    case SET_PLUGIN_LIST:
      return merge(state, { list: action.payload });
    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/redux/plugin/reducer.js
 **/